// extracted by mini-css-extract-plugin
export var measureBox = "_9m-0";